export default __webpack_public_path__ + "static/media/personal_branding.53b0c523.png";